import React from 'react';
import {Task} from "@/server/types";
import IconGuard from "@/assets/img/icon_guard.png"
import IconPrint from "@/assets/img/icon_print.png"
import IconShield from "@/assets/img/icon_shield.png"
import IconStorage from "@/assets/img/icon_storage.png"
import IconVision from "@/assets/img/icon_vision.png"
import {r} from "@/utils/responsive";

interface TaskIconProps extends React.HTMLAttributes<HTMLDivElement> {
    icon?: Task["rewardIcon"]
}

const TaskIcon: React.FC<TaskIconProps> = ({className, icon, ...props}) => {
    const getIconSrc = () => {
        switch (icon) {
            case 'guard':
                return IconGuard;
            case 'print':
                return IconPrint;
            case 'shield':
                return IconShield;
            case 'storage':
                return IconStorage;
            case 'vision':
                return IconVision;
            default:
                return IconGuard;
        }
    };

    return (
        <div
            {...props}
            style={{
                ...props.style,
                width: r.vmax(121),
                height: r.vmax(134),
            }}
        >
            <img 
                src={getIconSrc()} 
                alt={`${icon} icon`}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                }}
            />
        </div>
    );
};

export default TaskIcon;
